<template>
  <div class="userSubscribtion">
    <div class="subscribtionHeader">
      <h1 class="headerTitle">اشتراک من</h1>
      <div class="headerBackBtn" @click="historyBackHandler">
        <i class="fas fa-arrow-left"></i>
      </div>
    </div>
    <div class="subscribtionMain">
      <Skeletor v-if="tariffLoading" class="mainContainer mainContainerSk" />
      <div v-else-if="userTariff" class="mainContainer">
        <div class="containerHeader">
          <div class="headerTitle">{{ userTariff?.title }}</div>
        </div>
        <div class="containerMain">
          <div class="mainChart">
            <div class="chartRing" :style="`--p: ${leftPercent}%`">
              <div class="ringLabel">
                <div class="labelHeader">
                  <span>{{ userTariff?.left_day }}</span>
                  روز
                </div>
                <div class="labelFooter">باقی مانده</div>
              </div>
            </div>
            <div class="chartDates">
              <div class="dateItem">
                <span class="dateLabel">شروع اشتراک:</span>
                <span class="dateValue">{{ userTariff?.buy_date }}</span>
              </div>
              <div class="dateItem">
                <span class="dateLabel">پایان اشتراک:</span>
                <span class="dateValue">{{ userTariff?.expire_date }}</span>
              </div>
            </div>
          </div>
          <div v-if="tariffList.length > 0" class="mainItems">
            <div class="itemThumb" v-for="(v, i) in tariffList" :key="i">
              <div class="thumbHeader">
                <div class="headerTitle">{{ v.title }}</div>
                <div class="headerDetail" v-if="v.has_free">مصرف آزاد</div>
                <div class="headerDetail" v-else>
                  {{ v.value }} / {{ v.remainder }} مانده
                </div>
              </div>
              <div class="thumbMain">
                <div class="mainProgress">
                  <i :style="'--fw: ' + calculatePercentage(v) + '%'"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeletor } from "vue-skeletor";

export default {
  name: "userSubscribtion",
  components: {
    Skeletor,
  },
  data() {
    return {
      tariffList: [],
      userTariff: null,
      tariffLoading: false,
    };
  },
  computed: {
    leftPercent() {
      return this.userTariff
        ? Math.floor(
            (this.userTariff.left_day / this.userTariff.total_day) * 100
          )
        : 0;
    },
  },
  methods: {
    historyBackHandler() {
      history.back();
    },
    getUserSubscrubtionHandler() {
      this.tariffLoading = true;
      this.helperPost("tariff-remainder")
        .then((response) => {
          if (response.data.result == 1) {
            this.tariffList = response.data.data;
          }
          this.tariffLoading = false;
        })
        .catch((err) => {
          console.error(err);
          this.tariffLoading = false;
        });
    },
    calculatePercentage(item) {
      if (item.has_free) return 100;
      if (!item.value || item.value == 0) return 0;
      return Math.round((item.remainder / item.value) * 100);
    },
  },
  mounted() {
    const userRaw = localStorage.getItem("auth");
    this.userTariff = userRaw ? JSON.parse(userRaw)?.user_tariff || null : null;
    this.getUserSubscrubtionHandler();
  },
};
</script>

<style scoped lang="scss">
.dark {
  .userSubscribtion {
    background: #1e262f;

    .subscribtionHeader {
      background: #101a23;
      color: #fff;
      box-shadow: 0 1px 3px 0 rgba(255, 255, 255, 0.1),
        0 1px 2px -1px rgba(255, 255, 255, 0.1);
    }

    .subscribtionMain {
      .mainContainer {
        background: #101a23;
        box-shadow: 0 2px 4px 0 rgba(255, 255, 255, 0.05);
        border-color: #4e4d4d;
        color: #fff;

        .containerMain {
          .mainChart {
            border-color: #3e3e3e;
            .chartRing {
              background: conic-gradient(
                #0096c7 var(--p, 0%),
                rgba(255, 255, 255, 0.08) 0
              );
              .ringLabel {
                background: #101a23;
                color: #fff;
              }
            }
            .chartDates {
              .dateItem {
                background: rgba(14, 165, 233, 0.08);

                &:hover {
                  background: rgba(14, 165, 233, 0.12);
                }

                .dateLabel {
                  color: rgba(157, 165, 182, 0.75);
                }
              }
            }
          }

          .mainItems {
            .itemThumb {
              &:not(:last-child) {
                border-color: #3e3e3e;
              }

              .thumbHeader {
                .headerDetail {
                  color: rgba(157, 165, 182, 0.75);
                }
              }

              .thumbMain {
                .mainProgress {
                  background: rgba(255, 255, 255, 0.08);
                }
              }
            }
          }
        }
      }
    }
  }
}
.userSubscribtion {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: #f9fafb;
  overflow-y: auto;
  scrollbar-width: none;

  .subscribtionHeader {
    position: fixed;
    inset-inline: 0;
    inset-block-start: 0;
    width: 100%;
    height: 54px;
    background: #fff;
    z-index: 99;
    padding-inline: 24px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
      0 1px 2px -1px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;

    .headerTitle {
      font-size: 1.25rem !important;
      font-family: "iranyekanB", sans-serif;
      font-weight: 500;
    }

    .headerBackBtn {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      i {
        font-size: 1.5rem;
      }
    }
  }

  .subscribtionMain {
    width: 100%;
    padding: 84px 0 42px;

    .mainContainer {
      width: calc(100% - 48px);
      max-width: 640px;
      margin-inline: auto;
      border-radius: 16px;
      background: #fff;
      border: 1px solid #eaeaea;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
      overflow: hidden;

      &.mainContainerSk {
        height: 574px;
        display: block;
        background: rgb(163, 219, 213);
      }

      .containerHeader {
        width: 100%;
        background: #0096c7;
        padding: 16px;
        color: #fff;

        .headerTitle {
          font-size: 0.95rem;
          font-family: "iranyekanB", sans-serif;
        }

        .headerDetails {
          font-size: 0.85rem;
          display: flex;
          align-items: center;
          gap: 4px;

          span {
            font-weight: 600;
            letter-spacing: 0.75px;
          }
        }
      }

      .containerMain {
        width: 100%;
        padding: 32px 0 12px;

        .mainChart {
          padding-inline: 24px;
          padding-bottom: 32px;
          border-bottom: 1px solid #e2e8f0;

          .chartRing {
            width: 90%;
            max-width: 182px;
            aspect-ratio: 1;
            margin-inline: auto;
            border-radius: 999px;
            background: conic-gradient(
              #0096c7 var(--p, 0%),
              rgba(15, 23, 42, 0.08) 0
            );
            display: grid;
            place-items: center;

            .ringLabel {
              width: calc(100% - 28px);
              height: calc(100% - 28px);
              border-radius: 999px;
              background: #fff;
              border: 1px solid rgba(15, 23, 42, 0.07);
              display: flex;
              align-items: center;
              flex-direction: column;
              justify-content: center;

              .labelHeader {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 6px;
                font-size: 1.5rem;
                font-family: "iranyekanB", sans-serif;
                line-height: 1.5;

                span {
                  font-size: 2.25rem;
                  font-weight: 700;
                  line-height: 1.5;
                }
              }

              .labelFooter {
                font-size: 1rem;
                margin-top: -4px;
              }
            }
          }
          .chartDates {
            margin-top: 24px;
            display: flex;
            flex-direction: column;
            gap: 8px;

            .dateItem {
              display: flex;
              align-items: center;
              justify-content: space-between;
              font-size: 0.85rem;
              background: rgba(14, 165, 233, 0.05);
              padding: 10px 14px;
              border-radius: 8px;
              transition: background 0.2s ease;

              &:hover {
                background: rgba(14, 165, 233, 0.08);
              }

              .dateLabel {
                color: rgba(15, 23, 42, 0.65);
              }

              .dateValue {
                font-weight: 600;
                letter-spacing: 0.5px;
                font-family: "iranyekanB", sans-serif;
              }
            }
          }
        }

        .mainItems {
          .itemThumb {
            padding: 18px 20px;

            &:not(:last-child) {
              border-bottom: 1px solid #e2e8f0;
            }

            .thumbHeader {
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              .headerTitle {
                line-height: 1.5;
                font-size: 0.8rem;
                font-family: "iranyekanB", sans-serif;
              }

              .headerDetail {
                font-size: 12px;
                color: rgba(15, 23, 42, 0.75);
                white-space: nowrap;
              }
            }

            .thumbMain {
              .mainProgress {
                height: 10px;
                background: rgba(15, 23, 42, 0.08);
                border-radius: 999px;
                overflow: hidden;

                i {
                  display: block;
                  height: 100%;
                  width: var(--fw, 0%);
                  background: rgba(0, 150, 199, 0.95);
                  border-radius: 999px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
